import React, { useState } from "react";
import "tailwindcss/tailwind.css";
import { useTheme } from "../../services/ThemeProvider";

const Slider = ({
  min = 0,
  max = 100,
  step = 1,
  initialValue = 50,
  onValueChange,
}) => {
  const [value, setValue] = useState(initialValue);
  const { resolvedTheme } = useTheme();

  const handleChange = (e) => {
    const newValue = Number(e.target.value);
    setValue(newValue);
    if (onValueChange) {
      onValueChange(newValue); // Emit event when value changes
    }
  };

  // The inline gradient overrides any Tailwind bg-* class, so the unfilled
  // track color has to be picked here based on the resolved theme.
  const unfilledColor = resolvedTheme === "dark" ? "#374151" : "#e5e7eb";

  return (
    <div className="w-full">
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500" // dark-ok: the inline gradient below always paints over this bg; unfilledColor handles dark
        style={{
          background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${((value - min) / (max - min)) * 100}%, ${unfilledColor} ${((value - min) / (max - min)) * 100}%, ${unfilledColor} 100%)`,
        }}
      />

      <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mt-2">
        <span>{min}</span>
        <span>{value}</span>
        <span>{max}</span>
      </div>
    </div>
  );
};

export default Slider;
